import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentPathnameFromState } from '../../../lib/RouteUtils';
import { type State } from '../../../types';
import * as Utils from '../../../utils';

interface IScrollToTopProps {
  pathname: string;
}

function ScrollToTop({ pathname }: IScrollToTopProps): null {
  React.useEffect(() => {
    Utils.Scroll.scrollToTop();
  }, [pathname]);

  return null;
}

ScrollToTop.propTypes = {
  pathname: PropTypes.string,
};

export function mapStateToProps(state: State): IScrollToTopProps {
  const pathname = getCurrentPathnameFromState(state);

  return {
    pathname,
  };
}

export default connect(mapStateToProps)(ScrollToTop);
